export default __webpack_public_path__ + "locales/lo-LA/InviteDialog.json?hash=f723020b934961a62736d9eacc6ae008";